import React, { Component } from 'react'
import { Button, Loading } from 'carbon-components-react'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import PropTypes from 'prop-types'
import { ChangePasswordViewModel } from '../../models/ChangePasswordViewModel'
import ChangePasswordAPI from '../api/ChangePasswordAPI'
import PasswordSection from '../shared/passwordSection/PasswordSection'
import { trackEventMessage, trackEventMessageFailure } from '../../TelemetryService' 
import { EventModel } from './../../models/EventModel'
import { PASSWORD_CHANGE } from './../../constants'

export default class ChangePassword extends Component  {

    constructor() {
        super()
        this.state = {
            password: '',
            passwordConfirmation:'',
            loading: false,
            focus:false,
            isFirstFocus:true,
            pswConfError:null,
            pswError:null,
            enableSubmit:false,
            messageNewPassword: null,
            messageReEnterPassword: null
        }
        this.setPasswordValue = this.setPasswordValue.bind( this )
        this.setPasswordConfirmationValue = this.setPasswordConfirmationValue.bind( this )
        this.setPasswordIsValid = this.setPasswordIsValid.bind( this )
        this.handleSubmit = this.handleSubmit.bind( this )
    }
    get changePasswordApiUrl() {
        return this.config.changePasswordApiUrl || process.env.REACT_APP_CHANGE_PASSWORD_API_URL
    }
    get changePasswordViewModel() {
        return this.props.config.changePasswordViewModel || {}
    }
    get config() {
        return this.props.config || {}
    }
    get logInUrl() {
        return this.config.logInUrl || process.env.REACT_APP_LOG_IN 
    } 

    handleSubmit = ( event ) => {
        event.preventDefault()
      
        const { showConfirmation } = this.props
        const { enableSubmit, password, passwordConfirmation } = this.state

        this.setState( { loading: true } )
        if( enableSubmit ){
            ChangePasswordAPI( {
                userId : this.changePasswordViewModel.userId,
                password : password,
                confirmPassword : passwordConfirmation,
                hiddenValue : this.changePasswordViewModel.hiddenValue,
                secureId : this.changePasswordViewModel.secureId,
                email : this.changePasswordViewModel.email,
                apiUrl: this.changePasswordApiUrl
            } )
            .then( () => {
                trackEventMessage( new EventModel( PASSWORD_CHANGE.SUCCESS,this.changePasswordViewModel.userId ) )
                showConfirmation()
            } )
            .catch( ( e ) => {
                trackEventMessageFailure( new EventModel( PASSWORD_CHANGE.FAILURE,this.changePasswordViewModel.userId ), e )
                showConfirmation()
            } )
        }else{
            this.setState( { loading: false } )
        }
    }

    setPasswordValue = ( password ) => {
        this.setState( { password: password } )
    }

    setPasswordConfirmationValue = ( passwordConfirmation ) => {
        this.setState( { passwordConfirmation: passwordConfirmation } )
    }

    setPasswordIsValid =( isValid ) => {
        this.setState( { passwordIsValid: isValid, enableSubmit: isValid } )
    }

    render() {
        const passwordConfig = {
          className: 'c-form-input',
          inputWrapperClassName: 'mb-7'
        }
  
        const passwordConfirmationConfig = {
          className: 'c-form-input',
          inputWrapperClassName: 'mb-8'
        }

        const{ loading, enableSubmit, password, passwordConfirmation } = this.state
        const { email, passwordCriteriaNotMet } = this.changePasswordViewModel
        const title = 'Update your Password'
        return (
            <>
                <main className="c-main forgot-password">
                    <div className="os-container--max-width">
                        <div className="c-form-card" tabIndex={ 0 } >                    
                            <div className="c-form-card__container">
                                <form onSubmit = { this.handleSubmit }>
                                    <h1 className="o-heading-alpha" tabIndex={ 0 }>
                                        { title }
                                    </h1>
                                    {
                                    passwordCriteriaNotMet ?
                                        <p className="mb-7" data-testid="password-criteria-not-met-msg">Your password does not meet Eversource password security requirements. We'll need you to update your password to continue.</p>
                                    : null
                                    }
                                    <PasswordSection
                                    displayTitle = { false }
                                    showInputComponentsInColum = { false }
                                    passwordConfig = { passwordConfig }
                                    passwordConfirmationConfig = { passwordConfirmationConfig }
                                    setPasswordIsValid = { this.setPasswordIsValid }   
                                    email = { email } 
                                    setPasswordValue = { this.setPasswordValue }
                                    setPasswordConfirmationValue = { this.setPasswordConfirmationValue }
                                    passwordValue = { password }
                                    passwordConfirmationValue = { passwordConfirmation }
                                    displayNotificacionBottom = { false }
                                    displayBox = { false }
                                    formInputsClass =  'c-form-group'                      
                                    pswAriaLabel = "New Password. Mandatory Field."
                                    pswConfariaLabel = "Re-Enter Password. Mandatory field."
                                    notification = {
                                        {
                                            contentWrapper: 'c-password-checklist',
                                            visible: true
                                        }
                                    }
                                    />
                                    {
                                        loading ?
                                            <Loading
                                            description= { null } className="center-spinner" withOverlay={ false } small = { true }
                                            />
                                            :
                                            <Button   
                                            className={ ` ${ enableSubmit ? 'c-btn c-btn--primary' : 'c-btn c-btn--disabled' } mb-5` } 
                                            type="submit"
                                            tabIndex={ 0 }
                                            aria-label={ `Update Password ${ enableSubmit ? 'Enabled' : 'Disabled' } ` }
                                            data-testid="btn-Submit">
                                                Update Password
                                            </Button>
                                    }
                                    <div className="u-text-center mb-3">  
                                        <a href={ UrlBuilder( { url: this.logInUrl, buildURL: true } ) } className="c-link" tabIndex={ 0 }>Back to Sign In</a>
                                    </div>  
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        )
    }
}
ChangePassword.propTypes = {
    showConfirmation: PropTypes.func.isRequired,
    config: PropTypes.shape( {
        logInUrl: PropTypes.string,
        changePasswordUrlApiUrl: PropTypes.string,
        changePasswordViewModel: PropTypes.instanceOf( ChangePasswordViewModel ),
    } )
}